// extracted by mini-css-extract-plugin
export default {"container":"styles_container__QEDyH","underlinedTextWithPrimaryColor":"styles_underlinedTextWithPrimaryColor__A2T2-"};